__turbopack_context__.v({
  "accordionSlideOverwrite": "table-module-scss-module__HKhHdG__accordionSlideOverwrite",
  "fadeIn": "table-module-scss-module__HKhHdG__fadeIn",
  "fadeOut": "table-module-scss-module__HKhHdG__fadeOut",
  "scaleIn": "table-module-scss-module__HKhHdG__scaleIn",
  "scaleOut": "table-module-scss-module__HKhHdG__scaleOut",
  "table": "table-module-scss-module__HKhHdG__table",
  "tableBody": "table-module-scss-module__HKhHdG__tableBody",
  "tableCaption": "table-module-scss-module__HKhHdG__tableCaption",
  "tableCell": "table-module-scss-module__HKhHdG__tableCell",
  "tableFooter": "table-module-scss-module__HKhHdG__tableFooter",
  "tableHead": "table-module-scss-module__HKhHdG__tableHead",
  "tableHeader": "table-module-scss-module__HKhHdG__tableHeader",
  "tableLoadingOverlay": "table-module-scss-module__HKhHdG__tableLoadingOverlay",
  "tableRow": "table-module-scss-module__HKhHdG__tableRow",
  "zoomIn": "table-module-scss-module__HKhHdG__zoomIn",
  "zoomOut": "table-module-scss-module__HKhHdG__zoomOut",
});
